import React, { useState, useEffect } from "react";
import { filterReplacementStatic } from "../../static-data";
import { useIsMobile, usePauseOffscreenVideo } from "../../hooks";
import Slider from "react-slick";
const FilterReplacement = () => {
  const { title, description, features } = filterReplacementStatic;
  const isMobile = useIsMobile("1024");

  return (
    <div className="p-filter-replacement">
      <div className="container">
        <div className="p-filter-replacement__header">
          {title && <h2 className="p-filter-replacement__title">{title}</h2>}
          {description && (
            <div className="p-filter-replacement__description">
              {description}
            </div>
          )}
        </div>
        <div className="p-filter-replacement__body">
          {isMobile ? (
            <GridMobile features={features} />
          ) : (
            <GridDesktop features={features} />
          )}
        </div>
      </div>
    </div>
  );
};

function Feature({ feature }) {
  const { video, title, description } = feature;
  const videoRef = usePauseOffscreenVideo();
  return (
    <div
      className="p-filter-replacement__feature p-replacement-feature"
      key={title}
    >
      {feature.video && (
        <div className="p-replacement-feature__video">
          <video ref={videoRef} src={video} muted loop playsInline />
        </div>
      )}
      <div className="p-replacement-feature__content">
        {title && <h3 className="p-replacement-feature__title">{title}</h3>}
        {description && (
          <div className="p-replacement-feature__description">
            {description}
          </div>
        )}
      </div>
    </div>
  );
}

function GridDesktop({ features }) {
  return (
    <div className="p-filter-replacement__grid">
      {features.map((feature) => (
        <Feature key={feature.title} feature={feature} />
      ))}
    </div>
  );
}

function GridMobile({ features }) {
  const [isSliderInitialized, setIsSliderInitialized] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [progress, setProgress] = useState(0);
  const handleBeforeChange = (index) => {
    setCurrentSlide(index);
  };
  useEffect(() => {
    if (!isSliderInitialized) return;

    setProgress(-100);

    const interval = setInterval(() => {
      setProgress((prev) => (prev >= 0 ? -100 : prev + 1));
    }, 60);
    return () => clearInterval(interval);
  }, [isSliderInitialized, currentSlide]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    autoplaySpeed: 5000,
    arrows: false,
    autoplay: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    onInit: () => {
      setIsSliderInitialized(true);
    },
    beforeChange: (_, nextIdx) => {
      handleBeforeChange(nextIdx);
    },
  };

  return (
    <Slider
      {...settings}
      className="p-filter-replacement__slider"
      style={{ "--progress": `${progress}%` }}
    >
      {features.map((feature) => (
        <Feature key={feature.title} feature={feature} />
      ))}
    </Slider>
  );
}

export default FilterReplacement;
